/* TypeRenderer.js */

"use strict";

const _ = require("lodash");

class TypeRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("type-column");
        this._rootElem.component = this._model;
        this._snapshotIcon = document.createElement("base-icon-gl");
        this._snapshotIcon.dataset.icon = "configdrift.camera";
        this._rootElem.appendChild(this._snapshotIcon);

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("Type", (this._onType = this._onType.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("Type");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setType(this._model.getValue());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onType(newVal) {
        this._setType(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setType(newVal) {
        if (_.isUndefined(newVal)) {
            this._snapshotIcon.dataset.icon = "devicemanager.discovered";
        } else {
            this._snapshotIcon.dataset.icon = "configdrift.camera";
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = TypeRenderer;
